import script from "./ProductSafetyHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSafetyHeader.vue?vue&type=script&setup=true&lang=js"

import "./ProductSafetyHeader.vue?vue&type=style&index=0&id=2df2ec95&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2df2ec95"]])

export default __exports__